import React from "react";
import ServiciosComponent from "../components/home/ServiciosComponent";

const Servicios = () => {
  return <ServiciosComponent />;
};

export default Servicios;
